var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"result"}},[_c('router-link',{staticClass:"btnHome",attrs:{"to":{ name: 'Home' }}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('h1',[_vm._v("#null"),_c('span',{staticClass:"yellow"},[_vm._v(".")])]),_c('h2',[_vm._v("He who wanders is not always 404.")])])
}]

export { render, staticRenderFns }